import {useState} from 'react'

const usePapiEntities = (initialLoading = true, initialValue) => {
    const [entity, setEntity] = useState(initialValue)
    const [loading, setLoading] = useState(initialLoading)

    return {
        entity,
        setEntity,
        loading,
        setLoading
    }
}

export default usePapiEntities
